import {DocumentActions, SET_INTERNAL_USER_FIELD_VALUE, SET_EXTERNAL_USER_FIELD_VALUE, SET_USERS_ARRAY, SET_VALUE, } from '../actions/administrationModal';
import _ from 'lodash';
import {AppUser, Role} from '../../models/administration';
import { ProjectUser } from '../../models/projectRoles';

interface AdministrationState  {
    projectUsers: ProjectUser[],
    includeDeleted: boolean,
    busy: boolean,
    error?: string,
    mutationVersion: number,
    refreshAfterRoles: boolean,
    openModal: boolean,
    internalFilter?: string
    externalFilter?: string
    internalAppRoles: Role[],
    externalAppRoles: Role[]
    internalAppUsers: AppUser[],
    internalEditedUsers: AppUser[],
    externalAppUsers: AppUser[],
    externalEditedUsers: AppUser[],
}

const initialState: AdministrationState = {
    projectUsers: [],
    includeDeleted: false,
    busy: false,
    mutationVersion: 0,
    refreshAfterRoles: false,
    openModal: false,
    internalFilter: undefined,
    externalFilter: undefined,
    internalAppRoles: [],
    externalAppRoles: [],
    internalAppUsers: [],
    externalAppUsers: [],
    internalEditedUsers: [],
    externalEditedUsers: []
}

const updateUserField = (users: AppUser[], edited: AppUser[], payload: {email: string, rowKey?: string, name: string, value: any}) => {
    const matches = (user: AppUser) => payload.rowKey ? user.rowKey === payload.rowKey : user.email === payload.email;
    const original = users.find(matches);
    if (!original || original.isSelf) return {users, edited};
    const updated = {...original, [payload.name]: payload.value};
    return {
        users: users.map(user => matches(user) ? updated : user),
        edited: edited.some(matches) ? edited.map(user => matches(user) ? {...user, [payload.name]: payload.value} : user) : [...edited, updated]
    };
};


export const administrationModalReducer = (administrationModal = initialState, action : DocumentActions): AdministrationState => {
    switch (action.type) {
        
        case SET_INTERNAL_USER_FIELD_VALUE: {
            const updated = updateUserField(administrationModal.internalAppUsers, administrationModal.internalEditedUsers, action.payload);
            return {...administrationModal, internalAppUsers: updated.users, internalEditedUsers: updated.edited};
        }
            
        case SET_EXTERNAL_USER_FIELD_VALUE: {
            const updated = updateUserField(administrationModal.externalAppUsers, administrationModal.externalEditedUsers, action.payload);
            return {...administrationModal, externalAppUsers: updated.users, externalEditedUsers: updated.edited};
        }
            
        case SET_USERS_ARRAY:
            return {...administrationModal, [action.payload.arrayName]: (!action.payload.adding) ? action.payload.users : [...(administrationModal as any)[action.payload.arrayName], ...action.payload.users]        
            } 

        case SET_VALUE:
            return {...administrationModal, [action.payload.name]: action.payload.value };


        default:
            return administrationModal;
    }
};

// select from state (read)
const selectAdministrationState = (state: any) => state.administrationModal as AdministrationState;
export const getInternalAppUsers = (state: any) => selectAdministrationState(state).internalAppUsers;
export const getExternalAppUsers = (state: any) => selectAdministrationState(state).externalAppUsers;
export const getInternalEditUsers = (state: any) => selectAdministrationState(state).internalEditedUsers;
export const getExternalEditUsers = (state: any) => selectAdministrationState(state).externalEditedUsers;
export const getOpenModal = (state: any) => selectAdministrationState(state).openModal;
export const getInternalAppRoles = (state: any) => selectAdministrationState(state).internalAppRoles;
export const getExternalAppRoles = (state: any) => selectAdministrationState(state).externalAppRoles;
export const getInternalFilter = (state: any) => selectAdministrationState(state).internalFilter;
export const getExternalFilter = (state: any) => selectAdministrationState(state).externalFilter;
export const getProjectUsers = (state: any) => selectAdministrationState(state).projectUsers;
export const getIncludeDeleted = (state: any) => selectAdministrationState(state).includeDeleted;
export const getUsersBusy = (state: any) => selectAdministrationState(state).busy;
export const getUsersError = (state: any) => selectAdministrationState(state).error;
export const getUsersMutationVersion = (state: any) => selectAdministrationState(state).mutationVersion;
export const getUsersRefreshAfterRoles = (state: any) => selectAdministrationState(state).refreshAfterRoles;

